import axios from 'axios';
import { getUrlParams } from './util';
import { postRefreshTokenApi } from '@/api/api';
// 创建 Axios 实例
const service = axios.create({
    baseURL: process.env.NODE_ENV == 'production'? '': `/api`, // 替换为你的 API 基础 URL
    timeout: 6000 // 请求超时时间
});

const urlParams = getUrlParams(window.location.href);
if(urlParams.token){
  localStorage.setItem("aiToken",urlParams.token)
}
if(urlParams.refreshToken){
  localStorage.setItem("refreshToken",urlParams.refreshToken)
}
// 请求拦截器
service.interceptors.request.use(
    config => {
        // config.headers.post['Content-Type'] = 'application/json;charset=utf8';
        config.headers['token'] = urlParams.token || localStorage.getItem("aiToken"); // 替换为你的 token
        // config.headers['userId'] = urlParams.userId || '1'; // 替换为你的 token
        config.headers['luyongProjectId'] = urlParams.projectId || '';
        return config;
    },
    error => {
        // 处理请求错误
        console.log(error);
        return Promise.reject(error);
    }
);
let refreshing = false
function awaitRefeshingFn() {
  return new Promise((resolve) => {
    setTimeout(async () => {
    console.log(refreshing);
    if (!refreshing) {
      resolve(true)
    } else {
      await awaitRefeshingFn()
      resolve(true)
    }
  }, 1000)
})
}
// 响应拦截器
service.interceptors.response.use(
  async (resp) => {
        // 对响应数据做点什么
        // const res = response.data;
        // console.log(1111)
        // console.log(res)
        // return res;

      const res = resp.data;
      const { url, method, params, data, headers } = resp.config;

      const { code } = resp.data;
      if (res.code === 3000)
      {
        if (url === '/api/refresh/token') {
          //localStorage.removeItem("refreshToken")
          alert("会话过期").then(()=>{
            wx.miniProgram.navigateTo({
              url: '/pages/home/home'
            });
          })
          return false
        }

        if (!refreshing) {
          refreshing = true;
          let data = await postRefreshTokenApi({refreshToken: localStorage.getItem("refreshToken")});
          setTimeout(() => {
            refreshing = false;
          }, 300)
          localStorage.setItem(data.data.token);
        }

        // 等待接口请求完毕
        await awaitRefeshingFn();
        return this.request({ method: method, url, headers: headers, data, params })
      }else {
        return res
      }


    },
    error => {
        // 处理响应错误
        console.log('err' + error);
        return Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/axios.js